<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
      <h2 class="text-lg font-bold mb-4">Seleccionar unidades de: {{ producto.nombre }}</h2>

      <div v-if="unidades.length === 0" class="text-sm text-gray-600">No hay unidades disponibles</div>
      <ul class="space-y-2">
        <li
          v-for="unidad in unidades"
          :key="unidad.id_unidad"
          class="border px-3 py-2 rounded flex items-center justify-between hover:bg-gray-50"
        >
          <label class="flex items-center gap-4">
            <input type="checkbox" :value="unidad" v-model="seleccionadas" />
            <div>
              <div class="font-medium">{{ unidad.numero_serie }}</div>
              <div class="text-xs text-gray-500">Estado: {{ unidad.estado }}</div>
            </div>
          </label>
        </li>
      </ul>

      <div class="mt-6 flex justify-between">
        <button @click="$emit('cerrar')" class="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400">Cancelar</button>
        <button
          @click="agregarSeleccionadas"
          class="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Agregar a orden ({{ seleccionadas.length }})
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SeleccionarUnidades',
  props: {
    producto: Object
  },
  data() {
    return {
      unidades: [],
      seleccionadas: []
    }
  },
  mounted() {
    this.cargarUnidades()
  },
  methods: {
    async cargarUnidades() {
      try {
        const res = await axios.get(`/api/almacen/unidades/por-producto/${this.producto.id_producto}`)
        this.unidades = res.data.filter(u => u.estado === 'almacen')
      } catch (error) {
        console.error('Error al cargar unidades del producto:', error)
      }
    },
    agregarSeleccionadas() {
      const productosConFormato = this.seleccionadas.map(u => ({
        id_unidad: u.id_unidad,
        nombre_producto: this.producto.nombre,
        numero_serie: u.numero_serie
      }))
      this.$emit('agregar', productosConFormato)
    }
  }
}
</script>
